
import { MapLocation } from '@/types/location';

export const riyadhSchools: MapLocation[] = [
  {
    id: 70025,
    name: "Manarat (Izdihar) - Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 351
    }
  },
  {
    id: 70026,
    name: "Manarat (Izdihar) - Elementary Female",
    type: "School",
    devices: 2,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 402
    }
  },
  {
    id: 70027,
    name: "Manarat (Izdihar) - Intermediate/Secondary Female",
    type: "School",
    devices: 1,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate, Secondary",
      students: 432
    }
  },
  // Al-Rowad Private Schools (Izdihar)
  {
    id: 70047,
    name: "Al-Rowad Private Schools (Izdihar) - Elementary Male",
    type: "School",
    devices: 2,
    coordinates: [24.782234, 46.7212321],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 70048,
    name: "Al-Rowad Private Schools (Izdihar) - Intermediate Male",
    type: "School",
    devices: 2,
    coordinates: [24.782234, 46.7212321],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 394
    }
  },
  {
    id: 70049,
    name: "Al-Rowad Private Schools (Izdihar) - Elementary Female",
    type: "School",
    devices: 2,
    coordinates: [24.782234, 46.7212321],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 210
    }
  },
  {
    id: 70050,
    name: "Al-Rowad Private Schools (Izdihar) - Intermediate Female",
    type: "School",
    devices: 2,
    coordinates: [24.782234, 46.7212321],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 349
    }
  },
  // Additional schools
  {
    id: 70051,
    name: "Danat Al Uloom School",
    type: "School",
    devices: 3,
    coordinates: [24.8084423, 46.6090534],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 613
    }
  },
  {
    id: 70059,
    name: "Almanhal (At Taawaun)",
    type: "School",
    devices: 4,
    coordinates: [24.7659169, 46.6952629],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1845
    }
  }
];
